module.exports = __webpack_public_path__ + "static/media/bfile-retirement.2e865e9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-retirement.svg
// module id = 974
// module chunks = 0